export default {
  ROUTE_CHANGE_ERROR: '$stateChangeError',
  ROUTE_CHANGE_SUCCESS: '$stateChangeSuccess',
  ROUTE_CHANGE_START: '$stateChangeStart'
};
